import { LangType } from '../../helpers/lang';
import { buildParams } from '../../helpers/path';
import { PaginationRequest } from '../../types/pagination';
import { CustomCacheRequest, SortRequest } from '../../types/props';
import { DishType } from './dish-api';
import { managerApiUrl } from './manager-api';
import { baseFetch } from './utils.ts/base-fetch';

export type DishCategoryType = {
  id: number;
  section_id: number;
  name: LangType;
  dishes_count: number;
  dishes?: DishType[];
  sort_order: number;
};

const baseUrl = `${managerApiUrl}/menu`;

export type FetchDishCategoriesRequest = {
  section?: string[];
  name?: string;
  count?: string;
} & PaginationRequest &
  CustomCacheRequest &
  SortRequest;

export const fetchCategories = async (
  params: FetchDishCategoriesRequest,
): Promise<{ categories: DishCategoryType[] }> => {
  const { customCache, ...other } = params;
  const response = await baseFetch(baseUrl + '/category' + buildParams(other), { customCache });
  return response;
};

export const putCategory = async (params: Partial<DishCategoryType>): Promise<DishCategoryType> => {
  const response = await baseFetch(baseUrl + `/category/${params.id}`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });
  return response;
};

export const postCategory = async (
  params: Partial<DishCategoryType>,
): Promise<DishCategoryType> => {
  const response = await baseFetch(baseUrl + `/category`, {
    method: 'POST',
    body: JSON.stringify(params),
  });
  return response;
};

const isFullDeleteParam = {
  is_full_delete: false,
};

export const deleteCategory = async (id: string): Promise<void> => {
  const response = await baseFetch(baseUrl + `/category/${id}` + buildParams(isFullDeleteParam), {
    method: 'DELETE',
  });
  return response;
};

export const putCategoriesOrder = async (order: number[]) => {
  const response = await baseFetch(baseUrl + `/category/order`, {
    method: 'PUT',
    body: JSON.stringify({ order }),
  });
  return response;
};
